module.exports = __webpack_public_path__ + "static/media/f_hairstyle_wavy_medium_back_vector.53214019.svg";